export enum PRODUCT_BUNDLE_ENGINE_NAMES {
  BUNDLE = 'Bundle',
}

export enum PRODUCT_BUNDLE_FLAGS {
  FF_IS_ENABLED = 1880,
}

export enum ECardCurrency {
  EU = 'EURO',
  GB = 'POUND_STERLING',
}
